module.exports = __webpack_public_path__ + "static/media/054-belgium.ee1d9629.svg";